
/**
 * @type {import('@builder.io/sdk/dist/src/builder.class').Component}
 */
export default {
  name: 'magicSvgImageCard',
  friendlyName: 'Magic SVG Image Card',
  image: 'https://cdn.builder.io/api/v1/image/assets%2F69fac…a962e1cb3045ef%2Fac5a9d1ebe924e71b278c7cca6c8b804',
  inputs: [
    {
      name: 'magicPreviewMode',
      type: 'boolean',
      defaultValue: false,
      helperText: 'If true, the image will be rendered with the preview',
    },
    {
      name: 'materialImageUrl',
      type: 'string',
      showIf: (options) => options.get('magicPreviewMode'),
    },
    {
      name: 'materialNominalThickness',
      type: 'number',
      showIf: (options) => options.get('magicPreviewMode'),
    },
    {
      name: 'clickable',
      type: 'boolean',
      defaultValue: true,
      helperText: 'Makes the image card clickable, component must have an onClick function',
    },
    {
      name: 'description',
      type: 'string',
      helperText: 'Shows description of image if provided',
    },
    {
      name: 'imageData',
      type: 'object',
      subFields: [
        {
          name: 'id',
          type: 'string',
        },
        {
          name: 'prompt',
          type: 'string',
        },
        {
          name: 'svgUrl',
          type: 'string',
        },
        {
          name: 'imageUrl',
          type: 'string',
        },
        {
          name: 'artStyle',
          type: 'string',
        },
        {
          name: 'createdAt',
          type: 'string',
        },
        {
          name: 'additionalFields',
          type: 'object',
        },
        {
          name: 'userId',
          type: 'string',
        },
      ]
    },
    {
      name: 'width',
      type: 'number',
      defaultValue: 150,
      helperText: 'Width of the img in pixels',
    },
    {
      name: 'height',
      type: 'number',
      defaultValue: 150,
      helperText: 'Height of the img in pixel',
    },
    {
      name: 'showShare',
      type: 'boolean',
      defaultValue: true,
      helperText: 'Render share button on the image',
    },
  ],
};
